// TelcoTrack - Loading State Component
// Centered or compact loading indicator with optional message

import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-state',
  templateUrl: './loading-state.component.html',
  styleUrls: ['./loading-state.component.scss'],
})
export class LoadingStateComponent {
  @Input() message = 'Načítání…';
  @Input() spinnerSize: 'sm' | 'md' | 'lg' | 'xl' = 'md';
  /** Row layout with less padding (lists, panels). */
  @Input() compact = false;
  /** Minimal inline row (popups, hints). */
  @Input() inline = false;
  @Input() showMessage = true;
}
